import H from 'constants/httpMethod.const';
import { fromTaxToDto } from 'dto/taxes/fromTaxToDto.dto';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const beEditTax = actionEndpointBe('beEditTax', H.patch, 'sales/salon/:salonId/taxes/:id/', (options, extra) => ({
  ...options,
  inert: true,
  data: extra?.data,
  params: { id: fromAnyToTrimmed(extra?.id) },
  toDto: fromTaxToDto,
}));
